interface Props {
    className?: string
    pathClassName?: string
    FillColor?: string
    width?: string
    height?: string
}

export default function Close({
                                      className = '',
                                      pathClassName = '',
                                      FillColor = 'black',
                                        width= '40',
                                        height = '40'
                                  }:Props) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 24 24"
        >
            <path
                d="M18.121 19.1818C18.5896 19.6504 19.3494 19.6504 19.818 19.1818C19.9352 19.0646 19.9352 18.8746 19.818 18.7575L13.0605 11.9999L19.818 5.24241C19.9352 5.12525 19.9352 4.9353 19.818 4.81815C19.3494 4.34952 18.5896 4.34952 18.121 4.81815L11.9998 10.9393L5.87867 4.81815C5.41004 4.34952 4.65025 4.34952 4.18162 4.81815C4.06446 4.9353 4.06446 5.12525 4.18162 5.24241L10.9392 11.9999L4.18162 18.7575C4.06446 18.8746 4.06446 19.0646 4.18162 19.1818C4.65025 19.6504 5.41005 19.6504 5.87867 19.1818L11.9998 13.0606L18.121 19.1818Z"
                fill={FillColor}
                className={pathClassName}
            />
        </svg>
    )
}
